<template>
  <b-modal v-model="mostrarModal" title="Confirmar Dados">
    <p>Os dados atuais serão sobrescritos. Deseja continuar?</p>
    <b-table :items="formatarDados" :fields="['campo', 'valor']" striped responsive>
      <template v-slot:cell(Campo)="{ item }">
        <strong>{{ item.campo }}</strong>
      </template>
      <template v-slot:cell(Valor)="{ item }">
        {{ item.valor }}
      </template>
    </b-table>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
      <b-button variant="primary" @click="confirmar">Confirmar</b-button>
    </template>
  </b-modal>
</template>

<script>
import ConfirmacaoDados from './js/confirmacao-dados'
export default ConfirmacaoDados
</script>
